import React from 'react';
export function BonusSection() {
  return <section className="s-dark fu" data-id="element-29">
      <div className="c" data-id="element-30">
        <span className="slabel" data-id="element-31">Bonos incluidos sin costo extra</span>
        <h2 className="stitle" data-id="element-32">
          Comprás el ebook,
          <br data-id="element-33" />
          <em className="text-[var(--gold-l)]" data-id="element-34">recibís el kit completo.</em>
        </h2>
        <p className="ssub" data-id="element-35">
          Dos recursos adicionales diseñados para profundizar y sostener tu
          proceso, incluidos sin costo extra.
        </p>

        <div className="max-w-[860px] mx-auto mt-8 md:mt-[56px] flex flex-col gap-4 md:gap-[22px]" data-id="element-36">
          <div className="fu grid grid-cols-1 md:grid-cols-[160px_1fr] gap-5 md:gap-7 items-center bg-[var(--bg3)] border border-[rgba(212,184,150,0.2)] rounded-[20px] py-5 md:py-[30px] px-5 md:px-8 transition-all duration-300 relative overflow-hidden group shadow-[0_8px_32px_rgba(0,0,0,0.35)] text-center md:text-left" data-id="element-37">
            <div className="absolute top-0 left-0 right-0 h-[2px] bg-[linear-gradient(90deg,transparent,#C9A96E,#E8C88A,transparent)] opacity-0 transition-opacity duration-300 group-hover:opacity-100" data-id="element-38" />
            <img src="https://cdn.shopify.com/s/files/1/0752/3211/6894/files/BONO_1_04cb11de-8fc2-4f0e-a945-fc84bce08636.png?v=1772815275" alt="Diario Terapéutico de Liberación Emocional" className="w-full max-w-[140px] md:max-w-full mx-auto block rounded-[7px] shadow-[0_8px_24px_-6px_rgba(0,0,0,0.5)]" data-id="element-39" />
            <div className="flex flex-col items-center" data-id="element-40">
              <span className="inline-flex items-center py-1.5 px-4 bg-[linear-gradient(135deg,rgba(232,150,12,0.22),rgba(255,107,53,0.14))] border border-[rgba(232,150,12,0.5)] rounded-full text-[12px] font-bold tracking-[0.1em] uppercase text-[var(--gold-l)] mb-3 shadow-[0_0_16px_rgba(232,150,12,0.12)]" data-id="element-41">
                🎁 Bono 1 — Gratis
              </span>
              <h3 className="font-serif text-[clamp(1.3rem,4vw,1.6rem)] font-700 text-[var(--gold-l)] mb-2.5 text-center" data-id="element-42">
                Diario Terapéutico de Liberación Emocional
              </h3>
              <p className="text-[clamp(1.05rem,3vw,1.2rem)] text-[var(--text)] leading-[1.9] mb-4 font-400 text-center" data-id="element-43">
                Un proceso emocional se vuelve mucho más profundo cuando lo que
                sentís puede ser expresado y ordenado. Este diario guiado
                acompaña cada ritual y transforma la experiencia en un{' '}
                <strong className="text-[#E8C88A] font-700" data-id="element-44">
                  verdadero proceso de sanación personal
                </strong>
                .
              </p>
              <ul className="list-none flex flex-col gap-2 mb-4 max-w-[480px] mx-auto items-center" data-id="element-45">
                <li className="text-[clamp(1.05rem,3vw,1.2rem)] text-[var(--text)] flex items-start gap-[7px] leading-[1.9] font-400 text-left w-full" data-id="element-46">
                  <span className="text-[var(--gold)] text-[10px] flex-shrink-0 mt-2" data-id="element-47">
                    ✦
                  </span>
                  Ejercicios de escritura terapéutica para ordenar pensamientos
                  confusos
                </li>
                <li className="text-[clamp(1.05rem,3vw,1.2rem)] text-[var(--text)] flex items-start gap-[7px] leading-[1.9] font-400 text-left w-full" data-id="element-48">
                  <span className="text-[var(--gold)] text-[10px] flex-shrink-0 mt-2" data-id="element-49">
                    ✦
                  </span>
                  Preguntas guiadas para procesar emociones y comprender
                  patrones
                </li>
                <li className="text-[clamp(1.05rem,3vw,1.2rem)] text-[var(--text)] flex items-start gap-[7px] leading-[1.9] font-400 text-left w-full" data-id="element-50">
                  <span className="text-[var(--gold)] text-[10px] flex-shrink-0 mt-2" data-id="element-51">
                    ✦
                  </span>
                  Registro de cada ritual realizado (antes, durante y después)
                </li>
                <li className="text-[clamp(1.05rem,3vw,1.2rem)] text-[var(--text)] flex items-start gap-[7px] leading-[1.9] font-400 text-left w-full" data-id="element-52">
                  <span className="text-[var(--gold)] text-[10px] flex-shrink-0 mt-2" data-id="element-53">
                    ✦
                  </span>
                  Seguimiento emocional semanal durante 4 semanas
                </li>
                <li className="text-[clamp(1.05rem,3vw,1.2rem)] text-[var(--text)] flex items-start gap-[7px] leading-[1.9] font-400 text-left w-full" data-id="element-54">
                  <span className="text-[var(--gold)] text-[10px] flex-shrink-0 mt-2" data-id="element-55">
                    ✦
                  </span>
                  Espacios de escritura libre e introspección profunda
                </li>
              </ul>
              <div className="text-[clamp(1.05rem,3vw,1.2rem)] text-[var(--muted)] py-2 px-3 bg-[rgba(212,184,150,0.05)] rounded-md inline-block text-center mx-auto" data-id="element-56">
                Valor real: <s className="text-[var(--muted)]" data-id="element-57">$11.990 ARS</s>{' '}
                <strong className="text-[var(--gold-l)] ml-[5px] font-900" data-id="element-58">
                  → Incluido sin costo
                </strong>
              </div>
            </div>
          </div>

          <div className="fu grid grid-cols-1 md:grid-cols-[160px_1fr] gap-5 md:gap-7 items-center bg-[var(--bg3)] border border-[rgba(212,184,150,0.2)] rounded-[20px] py-5 md:py-[30px] px-5 md:px-8 transition-all duration-300 relative overflow-hidden group shadow-[0_8px_32px_rgba(0,0,0,0.35)] text-center md:text-left" data-id="element-59">
            <div className="absolute top-0 left-0 right-0 h-[2px] bg-[linear-gradient(90deg,transparent,#C9A96E,#E8C88A,transparent)] opacity-0 transition-opacity duration-300 group-hover:opacity-100" data-id="element-60" />
            <img src="https://cdn.shopify.com/s/files/1/0752/3211/6894/files/BONO_2_6bbd54e4-7ea7-4559-b798-8fb66bf71025.png?v=1772815275" alt="7 Rituales de Emergencia Emocional" className="w-full max-w-[140px] md:max-w-full mx-auto block rounded-[7px] shadow-[0_8px_24px_-6px_rgba(0,0,0,0.5)]" data-id="element-61" />
            <div className="flex flex-col items-center" data-id="element-62">
              <span className="inline-flex items-center py-1.5 px-4 bg-[linear-gradient(135deg,rgba(232,150,12,0.22),rgba(255,107,53,0.14))] border border-[rgba(232,150,12,0.5)] rounded-full text-[12px] font-bold tracking-[0.1em] uppercase text-[var(--gold-l)] mb-3 shadow-[0_0_16px_rgba(232,150,12,0.12)]" data-id="element-63">
                🎁 Bono 2 — Gratis
              </span>
              <h3 className="font-serif text-[clamp(1.3rem,4vw,1.6rem)] font-700 text-[var(--gold-l)] mb-2.5 text-center" data-id="element-64">
                7 Rituales de Emergencia Emocional
              </h3>
              <p className="text-[clamp(1.05rem,3vw,1.2rem)] text-[var(--text)] leading-[1.9] mb-4 font-400 text-center" data-id="element-65">
                Hay momentos en que las emociones aparecen con demasiada
                intensidad y no podés esperar. Ansiedad que llega de golpe.
                Tristeza que pesa. Enojo acumulado. En esos momentos, necesitás
                <strong className="text-[#E8C88A] font-700" data-id="element-66">
                  {' '}
                  volver a tu centro emocional ahora
                </strong>
                .
              </p>
              <ul className="list-none flex flex-col gap-2 mb-4 max-w-[480px] mx-auto items-center" data-id="element-67">
                <li className="text-[clamp(1.05rem,3vw,1.2rem)] text-[var(--text)] flex items-start gap-[7px] leading-[1.9] font-400 text-left w-full" data-id="element-68">
                  <span className="text-[var(--gold)] text-[10px] flex-shrink-0 mt-2" data-id="element-69">
                    ✦
                  </span>
                  7 rituales rápidos para momentos de crisis emocional aguda
                </li>
                <li className="text-[clamp(1.05rem,3vw,1.2rem)] text-[var(--text)] flex items-start gap-[7px] leading-[1.9] font-400 text-left w-full" data-id="element-70">
                  <span className="text-[var(--gold)] text-[10px] flex-shrink-0 mt-2" data-id="element-71">
                    ✦
                  </span>
                  Rituales para: ansiedad intensa, ruptura amorosa, culpa,
                  enojo, tristeza, miedo y emociones estancadas
                </li>
                <li className="text-[clamp(1.05rem,3vw,1.2rem)] text-[var(--text)] flex items-start gap-[7px] leading-[1.9] font-400 text-left w-full" data-id="element-72">
                  <span className="text-[var(--gold)] text-[10px] flex-shrink-0 mt-2" data-id="element-73">
                    ✦
                  </span>
                  Se realizan en minutos con elementos simples
                </li>
                <li className="text-[clamp(1.05rem,3vw,1.2rem)] text-[var(--text)] flex items-start gap-[7px] leading-[1.9] font-400 text-left w-full" data-id="element-74">
                  <span className="text-[var(--gold)] text-[10px] flex-shrink-0 mt-2" data-id="element-75">
                    ✦
                  </span>
                  A veces un pequeño acto simbólico devuelve la estabilidad
                  emocional
                </li>
              </ul>
              <div className="text-[clamp(1.05rem,3vw,1.2rem)] text-[var(--muted)] py-2 px-3 bg-[rgba(212,184,150,0.05)] rounded-md inline-block text-center mx-auto" data-id="element-76">
                Valor real: <s className="text-[var(--muted)]" data-id="element-77">$9.990 ARS</s>{' '}
                <strong className="text-[var(--gold-l)] ml-[5px] font-900" data-id="element-78">
                  → Incluido sin costo
                </strong>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}